

































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import CashPreAccountingApi from "../services/CashPreAccountingApi";
import { CashPreAccUploadItem } from "../models/CashPreAccEditing";
import { t } from "@/plugins/i18n";

interface Data {
  rows: CashPreAccUploadItem[];
  originalFlags: Record<number, boolean>;
  isLoading: boolean;
  isSaving: boolean;
}

interface Methods {
  load(): Promise<void>;
  setAll(value: boolean): void;
  formatAmount(value: number): string;
  save(): Promise<void>;
}

export default Vue.extend<Data, Methods, {}, { visible: boolean; statementId: number }>({
  name: "CashPreAccUploadItemsPanel",

  props: {
    visible: { type: Boolean, default: false },
    statementId: { type: Number, default: 0 },
  },

  data(): Data {
    return {
      rows: [],
      originalFlags: {},
      isLoading: false,
      isSaving: false,
    };
  },

  watch: {
    visible(value: boolean) {
      if (!value) return;
      this.load();
      // A panel a szerkesztő kártya alatt nyílik — görgessünk oda, hogy látszódjon
      this.$nextTick(() => (this.$el as HTMLElement)?.scrollIntoView?.({ block: "nearest", behavior: "smooth" }));
    },
  },

  methods: {
    async load() {
      this.rows = [];
      this.originalFlags = {};
      if (!this.statementId) return;
      this.isLoading = true;
      try {
        this.rows = await CashPreAccountingApi.getUploadItems(this.statementId);
        // Snapshot egyben (a soronkénti kulcs-bővítés Vue 2-ben nem reaktív)
        const flags: Record<number, boolean> = {};
        for (const row of this.rows) {
          flags[row.id] = row.isUp;
        }
        this.originalFlags = flags;
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
        this.$emit("close");
      } finally {
        this.isLoading = false;
      }
    },

    setAll(value: boolean) {
      for (const row of this.rows) {
        row.isUp = value;
      }
    },

    formatAmount(value: number): string {
      return new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 2 }).format(value ?? 0);
    },

    // K2D pb_ok: változás-ellenőrzés, majd tételenként az is_up flag mentése
    async save() {
      const changed = this.rows
        .filter((row) => this.originalFlags[row.id] !== row.isUp)
        .map((row) => ({ docItemId: row.id, isUp: row.isUp }));
      if (changed.length === 0) {
        eventBus.$emit("warn", t("NemValtoztatottSemmit"));
        return;
      }

      this.isSaving = true;
      try {
        await CashPreAccountingApi.saveUploadFlags(this.statementId, changed);
        eventBus.$emit("success", t("AFeladasJelolesekMentve"));
        // K2D záró figyelmeztetés — a beállítás az újrakontírozásig él
        eventBus.$emit(
          "warn",
          t("AzIttMegadottBeallitasokCsakA") +
            t("HaUjrakontirozzaAKivonatotUjraMeg")
        );
        this.$emit("close");
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isSaving = false;
      }
    },
  },
});
